/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_No_Target_FolderInputs */

const en_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Target Folder Selected`)
};

const fr_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun dossier cible sélectionné`)
};

const de_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Zielordner ausgewählt`)
};

const it_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna cartella di destinazione selezionata`)
};

const ru_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая папка не выбрана`)
};

const es_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ninguna carpeta de destino seleccionada`)
};

const zh_cn2_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择目标文件夹`)
};

const ja_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットフォルダが選択されていません`)
};

const hi_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई लक्ष्य फ़ोल्डर चयनित नहीं है`)
};

const pt_pt2_batch_subtitle_export_no_target_folder = /** @type {(inputs: Batch_Subtitle_Export_No_Target_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma pasta de destino selecionada`)
};

/**
* | output |
* | --- |
* | "No Target Folder Selected" |
*
* @param {Batch_Subtitle_Export_No_Target_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_no_target_folder = /** @type {((inputs?: Batch_Subtitle_Export_No_Target_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_No_Target_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "de") return de_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "it") return it_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "es") return es_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_no_target_folder(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_no_target_folder(inputs)
	return en_batch_subtitle_export_no_target_folder(inputs)
});